module.exports = __webpack_public_path__ + "media/src/img/code_typing-e2bc1c8fb048d36346fb8a4dd4c7b212c6df4cf68e3fc95aefa5d170a4483f77.svg";